// extracted by mini-css-extract-plugin
module.exports = {"MenuGrid":"MainMenu_MenuGrid__1wb6X","Menu":"MainMenu_Menu__OZ9Gy","Manager":"MainMenu_Manager__1ONkr","Alert":"MainMenu_Alert__UV97V","PartyBtn":"MainMenu_PartyBtn__295iR"};